<template>
    <v-form v-model="valid">
        <v-text-field
            v-model="numberOfTeams"
            label="Number of teams"
            required
        ></v-text-field>
        <v-text-field
            v-model="playersPerTeam"
            label="Players per team"
            required
        ></v-text-field>
        <v-btn :disabled="!valid"
            @click="draw">
        Generate
        </v-btn>
    </v-form>
</template>

<script>
import { db } from '../services/firebase';

export default {
  name: 'EventGenerateTeams',
  props: ['event'],
  data () {
      return {
          numberOfTeams: 3,
          playersPerTeam: 5,
          valid: true,
          participants: [],
          teams: [],
      }
  },
  computed: {
        invitedParticipants: function () {
            return this.participants.filter(participant => participant.status === 'invited');
        }, 
        comingParticipants: function () {
            return this.participants.filter(participant => participant.status === 'coming');
        }, 
  },
  firestore () {
      return  {
        
      }
  },
  mounted () {
    // Binding Collections
    this.$binding("participants", db.collection('events')
        .doc(this.event['.key']).collection('participants'));
    
    // Binding Docs
    this.$binding("teams", db.collection('participations_teams')
        .where('eventId', '==', this.event['.key']));
  },
  methods: {
    async draw () {
        let addedTeams = await db.collection('participations_teams').where('eventId', '==', this.event['.key']).get();
        const teams = await this.getTeams();

        if (addedTeams.empty) {
            await this.addTeamsToEvent(this.event, teams);
            addedTeams = await db.collection('participations_teams').where('eventId', '==', this.event['.key']).get();
        }

        let participants = this.comingParticipants.slice(0, this.numberOfTeams * this.playersPerTeam);
        participants = this.shuffleParticipants(participants);
        const playersPerTeam = this.splitTeams(participants, this.numberOfTeams);
        addedTeams.docs.forEach((team, index) => {
             team.ref.update({
                players: playersPerTeam[index].map(player => {
                    return {
                        displayName: player.displayName, 
                        playerId: player.participantId
                    }
                })
            });
        });
    },

    shuffleParticipants(participants) {
        let currentIndex = participants.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = participants[currentIndex];
            participants[currentIndex] = participants[randomIndex];
            participants[randomIndex] = temporaryValue;
        }

        return participants;
    },

    splitTeams(names, teams_count) {
        const teams = [];
        while (teams_count > 0) {
            teams.push(names.splice(0, Math.floor(names.length/teams_count)));
            teams_count--;
        }
        return teams;
    },

    async addTeamsToEvent(event, teams) {
        const ptRef = db.collection('participations_teams');
  
        // Begin a new batch
        const batch = db.batch();

        // Set each document, as part of the batch
        teams.forEach(team => {
            const ref = ptRef.doc();
            batch.set(ref, {
                eventId: event['.key'],
                eventTitle: event.title,
                teamId: team.id,
                teamName: team.name,
                createdAt: new Date()
            });
        });
    
        // Commit the entire batch
        return batch.commit();
    },

    async removeTeams () {

    },

    async getTeams (event) {
        const teamsRes = await db.collection('teams').get();
        let teams =  [];
        teamsRes.forEach(team =>{
            teams.push({
                id: team.id,
                name: team.data().name
            });
        });
        return teams;
    }
  }
}

</script>